export const ERROR_MESSAGES: Record<string, string> = {
  NoPIPointsFound: 'Aucun point PI trouvé dans la formule de la règle',
  ExtractedPIPointTagCannotBeFound:
    'Le tag de point PI extrait est introuvable dans le système PI.',
  FailedToFetchMetadataForTag: 'Échec de récupération des métadonnées pour le tag',
  FailedToGetPiPointDetailsForWebId:
    'Échec de désérialisation des détails du point PI',
    ErrorFetchingDataFromPISystem : 'Erreur lors de la récupération des données depuis le système PI',
    PiExpressionTranslationToPythonFailedWithCode : "L'appel Lambda a échoué avec le code de statut",
    BedrockCallFailed : 'le champ body manquant dans la réponse Lambda',
    PythonExpressionTestFailed : "Échec du test du Python",
    ProdTransitionRequirementsNotMet_ProdManual: "Impossible de passer au stade 'Prod Manuel'. Les conditions suivantes ne sont pas remplies",
    ProdTransitionRequirementsNotMet_ProdAutomated: "Impossible de passer au stade 'Prod Automatisé'. Les conditions suivantes ne sont pas remplies",
    AlertThresholdRequired: "au moins 1 seuil d'alarme doit être défini",
    PotentialCausesRequired: "au moins 1 cause potentielle est requise",
    PotentialConsequencesRequired: "au moins 1 conséquence potentielle est requise",
    CorrectiveActionsRequired: "au moins 1 action corrective est requise",
    WeeksBeforeFailureRequired: "la semaine avant défaillance doit être définie",
    NoRecentEvaluation: "La règle n'a pas été évaluée depuis plus de 2 fois sa période d'évaluation"
};
